import React, {Component} from 'react';
import {Link, withRouter} from 'react-router-dom';
import '../style/dashboardNew.scss';
import {Context} from "../tools/context";
import {authCall} from "../tools/apitools";
import AppLink from '../components/AppLink';
import AppButton from '../components/AppButton';
import {clientT} from '../tools/i18n';
import DateRangePicker from '../components/DateRangePicker';

class DashboardNew extends Component {
  constructor() {
    super();

    this.state = {
      giftNumber: 0,
      sellersKpis: [],
      dateRange: [null, null]
    }
  }

  componentDidMount() {
    if (Context.features.blockUnacceptedSeller) {
      const status = Context.seller.data.find(k => k.key === `${Context.partner.sponsor}_status`);
      if (status && status.value !== 'accepted')
        window.location.replace('/home')
    }
    if (Context.seller !== undefined && Context.seller.shortcode !== undefined) {
      authCall(`api/sellers/gifts?shortCode=${Context.seller.shortcode}`,
        {method: 'GET'},
        result => {
          this.setState({giftNumber: result && result.length});
        }, () => undefined);
      authCall(`/api/sellers/kpis`,
        {method: 'GET'},
        result => {
          this.setState({sellersKpis: result.filter((kpi) => kpi.date === null)});
        }, () => undefined);
    } else {
      this.props.history.replace("/connexion");
    }
}

  renderIcon = () => {
    return (<svg width="23" height="27" viewBox="0 0 23 27" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M6.83314 0.420906C6.94713 0.0939678 7.30413 -0.0788963 7.62982 0.0350938C7.95676 0.147831 8.12962 0.504833 8.01688 0.831771L6.7442 4.49323C8.17221 3.85188 9.74677 3.48235 11.4103 3.48235C17.7123 3.48235 22.8206 8.59186 22.8206 14.8939C22.8206 21.1959 17.7123 26.3042 11.4103 26.3054C5.10826 26.3042 0 21.1959 0 14.8939C0 13.4772 0.256791 12.118 0.73154 10.8641C0.853046 10.541 1.21381 10.3769 1.53824 10.4996C1.86267 10.6224 2.02552 10.9831 1.90276 11.3076C1.48062 12.4212 1.25264 13.6287 1.25264 14.8939C1.25264 17.701 2.38878 20.2364 4.22765 22.0765C6.06778 23.9154 8.60312 25.0515 11.4103 25.0528C14.2174 25.0515 16.7528 23.9154 18.5929 22.0765C20.4318 20.2364 21.5679 17.701 21.5679 14.8939C21.5679 12.0867 20.4318 9.55138 18.5929 7.71001C16.7528 5.87113 14.2174 4.73499 11.4103 4.73499C9.92465 4.73499 8.5242 5.06443 7.25528 5.63564L11.0119 7.00352C11.3364 7.12127 11.5042 7.48077 11.3852 7.80646C11.2675 8.13089 10.908 8.29875 10.5835 8.17974L5.44146 6.3083C5.40137 6.29453 5.37382 6.26697 5.33749 6.24567C5.30242 6.22438 5.26358 6.20935 5.23352 6.18179C5.20346 6.15423 5.18467 6.1179 5.16087 6.08533C5.13707 6.05277 5.10826 6.02521 5.09072 5.98888C5.07444 5.95381 5.07068 5.91372 5.06191 5.87614C5.05064 5.83606 5.0331 5.79848 5.03059 5.75589C5.02809 5.71706 5.04187 5.67823 5.04813 5.6394C5.05314 5.59681 5.05064 5.55547 5.06441 5.51538L6.83314 0.420906ZM12.5127 10.3006C13.2443 10.3006 13.9445 10.4484 14.5808 10.7177C14.899 10.853 15.0481 11.2213 14.9128 11.5394C14.7775 11.8576 14.4105 12.0067 14.091 11.8714C13.6075 11.666 13.0752 11.5532 12.5127 11.5532C10.9006 11.5557 9.52143 12.5015 8.86504 13.8631H12.6443C12.9912 13.8631 13.2706 14.1424 13.2706 14.4894C13.2706 14.8339 12.9912 15.1157 12.6443 15.1157H8.50303C8.48174 15.2798 8.45167 15.4427 8.45167 15.6143C8.45167 15.7846 8.48174 15.9462 8.50303 16.1116H12.6443C12.9912 16.1116 13.2706 16.3922 13.2706 16.7379C13.2706 17.0836 12.9912 17.3642 12.6443 17.3642H8.86504C9.52017 18.7246 10.9006 19.6703 12.5127 19.6741C13.0338 19.6741 13.5286 19.5764 13.9858 19.3985C14.3078 19.2732 14.6698 19.4323 14.7963 19.7542C14.9228 20.0774 14.7625 20.4407 14.4405 20.566C13.8418 20.7989 13.1904 20.9267 12.5127 20.9267C10.1941 20.9255 8.24499 19.4336 7.5172 17.3642H6.02657C5.68084 17.3642 5.40025 17.0836 5.40025 16.7379C5.40025 16.3922 5.68084 16.1116 6.02657 16.1116H7.24914C7.23286 15.945 7.19904 15.7846 7.19904 15.6143C7.19904 15.4427 7.23286 15.2823 7.24914 15.1157H6.02657C5.68084 15.1157 5.40025 14.8339 5.40025 14.4894C5.40025 14.1424 5.68084 13.8631 6.02657 13.8631H7.5172C8.24499 11.7937 10.1941 10.3006 12.5127 10.3006Z" fill="white"/>
    </svg>)
  }

  handleDateChange = (dateRange) => {
    let [startDate, endDate] = dateRange;

    this.setState({dateRange: dateRange});
    if (endDate !== null) {
      authCall(`/api/sellers/kpis`, {
        method: 'POST',
        body: JSON.stringify( {from: startDate, to: endDate})
      },
        (res) => this.setState({sellersKpis: res.filter((kpi) => kpi.date === null)})
      )
    }
  }

  render() {
    const {
      sellersKpis,
      dateRange,
    } = this.state;
    const phoneNumber = Context.partner?.dashboardNew?.phoneNumber || '';

    return (
      <div className="dashboard">
        <main className="main" id="main">
          <div style={{textAlign: "center"}}>
            <div className="date-wrapper" style={{marginTop: "30px"}}>
              <DateRangePicker dateRange={dateRange} onChange={this.handleDateChange} />
            </div>
            {sellersKpis &&
              <div className="kpi-wrapper">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: "20px",
                    marginBottom: "30px",
                    flexWrap: "wrap",
                    gap: "20px"
                  }}
                >
                  {sellersKpis.map((key) => (
                    <div
                      className="kpiDiv"
                      id={`${key.key}Div`}
                      key={key.key}
                      dangerouslySetInnerHTML={{
                        __html: clientT(`dashboardNew.${key.key}`, {
                          count: key.value
                        }) || `${key.explanation} : ${key.value}`
                      }}
                    />
                  ))}
                </div>
              </div>
            }
            {
              Context.partner.features && Context.partner.features.noTransaction ?
                  <AppLink href="/mes-clients" className={`btn monSoldeBtn`}>
                    <svg width="22" height="22" viewBox="0 0 23 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" clipRule="evenodd" d="M6.83314 0.420906C6.94713 0.0939678 7.30413 -0.0788963 7.62982 0.0350938C7.95676 0.147831 8.12962 0.504833 8.01688 0.831771L6.7442 4.49323C8.17221 3.85188 9.74677 3.48235 11.4103 3.48235C17.7123 3.48235 22.8206 8.59186 22.8206 14.8939C22.8206 21.1959 17.7123 26.3042 11.4103 26.3054C5.10826 26.3042 0 21.1959 0 14.8939C0 13.4772 0.256791 12.118 0.73154 10.8641C0.853046 10.541 1.21381 10.3769 1.53824 10.4996C1.86267 10.6224 2.02552 10.9831 1.90276 11.3076C1.48062 12.4212 1.25264 13.6287 1.25264 14.8939C1.25264 17.701 2.38878 20.2364 4.22765 22.0765C6.06778 23.9154 8.60312 25.0515 11.4103 25.0528C14.2174 25.0515 16.7528 23.9154 18.5929 22.0765C20.4318 20.2364 21.5679 17.701 21.5679 14.8939C21.5679 12.0867 20.4318 9.55138 18.5929 7.71001C16.7528 5.87113 14.2174 4.73499 11.4103 4.73499C9.92465 4.73499 8.5242 5.06443 7.25528 5.63564L11.0119 7.00352C11.3364 7.12127 11.5042 7.48077 11.3852 7.80646C11.2675 8.13089 10.908 8.29875 10.5835 8.17974L5.44146 6.3083C5.40137 6.29453 5.37382 6.26697 5.33749 6.24567C5.30242 6.22438 5.26358 6.20935 5.23352 6.18179C5.20346 6.15423 5.18467 6.1179 5.16087 6.08533C5.13707 6.05277 5.10826 6.02521 5.09072 5.98888C5.07444 5.95381 5.07068 5.91372 5.06191 5.87614C5.05064 5.83606 5.0331 5.79848 5.03059 5.75589C5.02809 5.71706 5.04187 5.67823 5.04813 5.6394C5.05314 5.59681 5.05064 5.55547 5.06441 5.51538L6.83314 0.420906ZM12.5127 10.3006C13.2443 10.3006 13.9445 10.4484 14.5808 10.7177C14.899 10.853 15.0481 11.2213 14.9128 11.5394C14.7775 11.8576 14.4105 12.0067 14.091 11.8714C13.6075 11.666 13.0752 11.5532 12.5127 11.5532C10.9006 11.5557 9.52143 12.5015 8.86504 13.8631H12.6443C12.9912 13.8631 13.2706 14.1424 13.2706 14.4894C13.2706 14.8339 12.9912 15.1157 12.6443 15.1157H8.50303C8.48174 15.2798 8.45167 15.4427 8.45167 15.6143C8.45167 15.7846 8.48174 15.9462 8.50303 16.1116H12.6443C12.9912 16.1116 13.2706 16.3922 13.2706 16.7379C13.2706 17.0836 12.9912 17.3642 12.6443 17.3642H8.86504C9.52017 18.7246 10.9006 19.6703 12.5127 19.6741C13.0338 19.6741 13.5286 19.5764 13.9858 19.3985C14.3078 19.2732 14.6698 19.4323 14.7963 19.7542C14.9228 20.0774 14.7625 20.4407 14.4405 20.566C13.8418 20.7989 13.1904 20.9267 12.5127 20.9267C10.1941 20.9255 8.24499 19.4336 7.5172 17.3642H6.02657C5.68084 17.3642 5.40025 17.0836 5.40025 16.7379C5.40025 16.3922 5.68084 16.1116 6.02657 16.1116H7.24914C7.23286 15.945 7.19904 15.7846 7.19904 15.6143C7.19904 15.4427 7.23286 15.2823 7.24914 15.1157H6.02657C5.68084 15.1157 5.40025 14.8339 5.40025 14.4894C5.40025 14.1424 5.68084 13.8631 6.02657 13.8631H7.5172C8.24499 11.7937 10.1941 10.3006 12.5127 10.3006Z" fill="white"/>
                    </svg>
                    <span style={{marginTop: '2px'}}>{Context.features?.KYCEnabled
                        ? clientT('dashboardNew.checkBalance') : clientT('dashboardNew.myCheckList')}</span>
                  </AppLink>
                  :
            <AppLink href="/mon-solde" className={`btn monSoldeBtn`}>
              <svg width="22" height="22" viewBox="0 0 23 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M6.83314 0.420906C6.94713 0.0939678 7.30413 -0.0788963 7.62982 0.0350938C7.95676 0.147831 8.12962 0.504833 8.01688 0.831771L6.7442 4.49323C8.17221 3.85188 9.74677 3.48235 11.4103 3.48235C17.7123 3.48235 22.8206 8.59186 22.8206 14.8939C22.8206 21.1959 17.7123 26.3042 11.4103 26.3054C5.10826 26.3042 0 21.1959 0 14.8939C0 13.4772 0.256791 12.118 0.73154 10.8641C0.853046 10.541 1.21381 10.3769 1.53824 10.4996C1.86267 10.6224 2.02552 10.9831 1.90276 11.3076C1.48062 12.4212 1.25264 13.6287 1.25264 14.8939C1.25264 17.701 2.38878 20.2364 4.22765 22.0765C6.06778 23.9154 8.60312 25.0515 11.4103 25.0528C14.2174 25.0515 16.7528 23.9154 18.5929 22.0765C20.4318 20.2364 21.5679 17.701 21.5679 14.8939C21.5679 12.0867 20.4318 9.55138 18.5929 7.71001C16.7528 5.87113 14.2174 4.73499 11.4103 4.73499C9.92465 4.73499 8.5242 5.06443 7.25528 5.63564L11.0119 7.00352C11.3364 7.12127 11.5042 7.48077 11.3852 7.80646C11.2675 8.13089 10.908 8.29875 10.5835 8.17974L5.44146 6.3083C5.40137 6.29453 5.37382 6.26697 5.33749 6.24567C5.30242 6.22438 5.26358 6.20935 5.23352 6.18179C5.20346 6.15423 5.18467 6.1179 5.16087 6.08533C5.13707 6.05277 5.10826 6.02521 5.09072 5.98888C5.07444 5.95381 5.07068 5.91372 5.06191 5.87614C5.05064 5.83606 5.0331 5.79848 5.03059 5.75589C5.02809 5.71706 5.04187 5.67823 5.04813 5.6394C5.05314 5.59681 5.05064 5.55547 5.06441 5.51538L6.83314 0.420906ZM12.5127 10.3006C13.2443 10.3006 13.9445 10.4484 14.5808 10.7177C14.899 10.853 15.0481 11.2213 14.9128 11.5394C14.7775 11.8576 14.4105 12.0067 14.091 11.8714C13.6075 11.666 13.0752 11.5532 12.5127 11.5532C10.9006 11.5557 9.52143 12.5015 8.86504 13.8631H12.6443C12.9912 13.8631 13.2706 14.1424 13.2706 14.4894C13.2706 14.8339 12.9912 15.1157 12.6443 15.1157H8.50303C8.48174 15.2798 8.45167 15.4427 8.45167 15.6143C8.45167 15.7846 8.48174 15.9462 8.50303 16.1116H12.6443C12.9912 16.1116 13.2706 16.3922 13.2706 16.7379C13.2706 17.0836 12.9912 17.3642 12.6443 17.3642H8.86504C9.52017 18.7246 10.9006 19.6703 12.5127 19.6741C13.0338 19.6741 13.5286 19.5764 13.9858 19.3985C14.3078 19.2732 14.6698 19.4323 14.7963 19.7542C14.9228 20.0774 14.7625 20.4407 14.4405 20.566C13.8418 20.7989 13.1904 20.9267 12.5127 20.9267C10.1941 20.9255 8.24499 19.4336 7.5172 17.3642H6.02657C5.68084 17.3642 5.40025 17.0836 5.40025 16.7379C5.40025 16.3922 5.68084 16.1116 6.02657 16.1116H7.24914C7.23286 15.945 7.19904 15.7846 7.19904 15.6143C7.19904 15.4427 7.23286 15.2823 7.24914 15.1157H6.02657C5.68084 15.1157 5.40025 14.8339 5.40025 14.4894C5.40025 14.1424 5.68084 13.8631 6.02657 13.8631H7.5172C8.24499 11.7937 10.1941 10.3006 12.5127 10.3006Z" fill="white"/>
              </svg>
              <span style={{marginTop: '2px'}}>{Context.features?.KYCEnabled
                ? clientT('dashboardNew.checkBalance') : clientT('dashboardNew.myCheckList')}</span>
              </AppLink>
            }
            {Context.partner &&
            Context.partner.features &&
            Context.partner.features.showClientSideLink && (
                <div
                    className="transaction-proceed scanner-cust"
                    style={{ width: "100%", marginTop: '10px'}}
                >
                  <Link
                      className="btn btn-primary btn-outlined magasin-transaction-btn"
                      style={{justifyContent: 'center'}}
                      to={"/portefeuille"}
                  >
                   {clientT('dashboardNew.voucherText')}
                  </Link>
                </div>)
            }
            {Context.partner &&
            Context.partner.features &&
            Context.partner.features.showQRScanner && (
              <div
                className="transaction-proceed scanner-cust"
                style={{ width: "100%", marginTop: '10px'}}
              >
                <AppButton
                  className="btn btn-primary btn-outlined magasin-transaction-btn"
                  style={{justifyContent: 'center'}}
                  onClick={() => {this.props.history.push(
                    "/magasin-home",
                     { magasinLite: true}
                  )}}
                  event="Scanner ou entrer un code"
                >
                  <svg
                    id="Scan"
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    viewBox="0 0 30 30"
                  >
                    <path
                      id="Tracé_716"
                      data-name="Tracé 716"
                      d="M0,0H30V30H0Z"
                      fill="none"
                    ></path>
                    <path
                      id="Tracé_717"
                      data-name="Tracé 717"
                      d="M4,7.75V6.5A2.5,2.5,0,0,1,6.5,4H9"
                      transform="translate(1 1)"
                      fill="none"
                      stroke="#ffffff"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokelinewidth="2"
                      strokeWidth="3"
                    ></path>
                    <path
                      id="Tracé_718"
                      data-name="Tracé 718"
                      d="M4,17v1.25a2.5,2.5,0,0,0,2.5,2.5H9"
                      transform="translate(1 4.25)"
                      fill="none"
                      stroke="#ffffff"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokelinewidth="2"
                      strokeWidth="3"
                    ></path>
                    <path
                      id="Tracé_719"
                      data-name="Tracé 719"
                      d="M16,4h2.5A2.5,2.5,0,0,1,21,6.5V7.75"
                      transform="translate(4 1)"
                      fill="none"
                      stroke="#ffffff"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokelinewidth="2"
                      strokeWidth="3"
                    ></path>
                    <path
                      id="Tracé_720"
                      data-name="Tracé 720"
                      d="M16,20.75h2.5a2.5,2.5,0,0,0,2.5-2.5V17"
                      transform="translate(4 4.25)"
                      fill="none"
                      stroke="#ffffff"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokelinewidth="2"
                      strokeWidth="3"
                    ></path>
                    <line
                      id="Ligne_23"
                      data-name="Ligne 23"
                      x2="12.188"
                      transform="translate(8.685 15.278)"
                      fill="none"
                      stroke="#ffffff"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokelinewidth="2"
                      strokeWidth="3"
                    ></line>
                  </svg>{" "}
                  <span style={{marginTop: '2px'}}>{clientT('dashboardNew.scanCodeText')}</span>
                </AppButton>
              </div>
            )}
            {
              Context.partner?.dashboardNew?.couponDiv ?
                <AppLink href="/mes-avantages">
                  <div className="couponDiv">
                    <p>{clientT('dashboardNew.myTip')} <span>({this.state.giftNumber})</span></p>
                    <div className="couponImagesWrapper">
                      <img
                        src="/assets/tcaAssets/28094612/gift-box.png"/>
                      <img
                        src="/assets/tcaAssets/28092644/Pourcent.png"/>
                      <img
                        src="/assets/tcaAssets/31150920/Coin.png"/>
                    </div>
                  </div>
                </AppLink> : null
            }

            <div className="kitDiv">
              {
                Context.partner.dashboardNew && Context.partner.dashboardNew.kitDivText ?
                  <p style={{textAlign: "center"}} dangerouslySetInnerHTML={{__html: Context.partner.dashboardNew.kitDivText}} />
                  :
                  <p dangerouslySetInnerHTML={{__html: clientT('dashboardNew.merchantCodeDisplayText')}} />
              }
              <div className="kitCardsWrapper">
                {(!Context.partner.dashboardNew || (Context.partner.dashboardNew && !Context.partner.dashboardNew.noKit)) &&
                <AppLink
                  href={Context.partner && Context.partner.bvnKitURL && Context.partner.bvnKitURL !== "" ? `${Context.partner.bvnKitURL}` : "/assets/tcaAssets/02200916/KIT-COMMUNICATION-Ticket-Commerçant.zip"}
                  className="kitBtn downloadKit"
                  style={{border: "solid 2px rgba(58, 69, 129, 0.13)"}}
                  anchor
                >
                  {clientT('dashboardNew.merchantKit')}
                </AppLink>
                }
                {!Context?.partner?.hideShortcode && <div className="kitBtn" style={{backgroundColor: "rgba(58, 69, 129, 0.13)", marginLeft: '2%'}}>
                  <strong id="shortCode">{Context.seller && Context.seller.shortcode && Context.seller.shortcode}</strong>
                </div>}
              </div>
              <div>
                <AppLink href="/inscription?registered=true" className={`btn monSoldeBtn`}>
                  <span style={{marginTop: '2px'}}>{clientT('register.createNewSalePoint')}</span>
                </AppLink>
              </div>
            </div>
            {/*{*/}
            {/*    Context.partner.dashboardNew && Context.partner.dashboardNew.carouselDiv ?*/}
            {/*    <div className="carouselDiv"></div> : null*/}
            {/*}*/}
            {
              Context.partner.dashboardNew && Context.partner.dashboardNew.footer ?
                <div className="footerWrapper">
                  <span dangerouslySetInnerHTML={{__html: clientT('dashboardNew.tollFreeNumberText')}}/><br/>
                  { phoneNumber && <AppLink className="footerNum" href={`tel:${phoneNumber.split(' ').join('')}`} anchor>{phoneNumber}</AppLink> }
                </div> : null
            }
          </div>
        </main>
      </div>
    )
  }
}

export default withRouter(DashboardNew);
